import anchorAnimate from './modules/anchor-animate';
import hideOnScroll from './modules/hide-on-scroll';
import landingWrapper from './modules/landing-wrapper';
import mobMenuDropdowns from './modules/mob-menu-dropdowns';
import scrollToHorizontal from './modules/scroll-to-horizontal';
import setPageMinHeight from './modules/set-page-min-height';
import utmTracking from './modules/utm-tracking';

( function ( $ ) {
    'use strict';

    $( function() {
        anchorAnimate.init();
        hideOnScroll.init();
        landingWrapper.init();
        mobMenuDropdowns.init();
        scrollToHorizontal.init();
        setPageMinHeight.init();
        utmTracking.init();
    } );

} )( jQuery );
